module.exports = "/fonts/payjak-picturemark-l-88b7aabcf5a21ef5f279db6e921e2c51.svg";